import { Box, Card, CardContent, Typography, useTheme } from "@mui/material";
import type { TestimonialCardProps } from "./types/TestimonialCardProps";

export function TestimonialCard({ company, name, photo, testimonial, local }: TestimonialCardProps) {
  const theme = useTheme();

  return (
    <Box sx={{ position: "relative", width: "100%", paddingTop: "50px" }}>
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: "50%",
          overflow: "hidden",
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 2,
          border: `3px solid ${theme.palette.background.paper}`,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <img style={{ width: "100%", height: "100%", objectFit: "cover" }} src={photo} alt={name} />
      </Box>

      <Card
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          pt: 6,
          boxSizing: "border-box",
        }}
      >
        <CardContent sx={{ flex: 1, textAlign: "center", position: "relative" }}>
          <Typography sx={{ fontSize: { xs: "14px", sm: "16px" } }}>
            <span style={{ color: theme.palette.primary.main, fontWeight: "bold" }}>“</span>
            {testimonial}
            <span style={{ color: theme.palette.primary.main, fontWeight: "bold" }}>”</span>
          </Typography>
        </CardContent>

        <Box sx={{ textAlign: "center", marginBottom: 1 }}>
          <Typography sx={{ fontWeight: "bold", color: theme.palette.primary.main }}>{name}</Typography>
          <Typography sx={{ fontSize: "12px" }}>{company}</Typography>
          {local && <Typography sx={{ fontSize: "12px" }}>{local}</Typography>}
        </Box>
      </Card>
    </Box>
  );
}
